module.exports = __webpack_public_path__ + "images/emoji/arrow_right_hook.dff55ba1ebec38901e11.png";